import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from 'config/constants';

export default class UserName extends PureComponent {
    static propTypes = {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        hashId: PropTypes.string,
        className: PropTypes.string
    }

    static defaultProps = {
        firstName: '',
        lastName: '',
        className: ''
    }

    render() {
        const { hashId, firstName, lastName, className } = this.props;
        const content = `${firstName} ${lastName ? `${lastName.substr(0, 1)}.` : ''}`;

        if (hashId) {
            return (
                <Link className={className} to={ROUTE_PATHS.PROFILE(hashId)}>
                    {content}
                </Link>
            );
        }

        return (
            <span className={className}>
                {content}
            </span>
        );
    }
}
